module.exports = "<h2 class=\"text-center\">Coming Soon!</h2>\n"